export default "__VITE_ASSET__2a4371aa__"